// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__SVeJo","col":"styles_col__YqT_9","actions":"styles_actions__2RRZN","conflict":"styles_conflict__2xbNx"};